import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Card, CardContent } from '@/components/atoms/card'
import { Calendar } from 'lucide-react'

export interface CardNewsMediumProps {
  image?: string
  title: string
  date: string
  link?: string
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  onClick?: () => void
}

export default function CardNewsMedium({
  image,
  title,
  date,
  link,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: CardNewsMediumProps) {
  return (
    <Card
      className="bg-white rounded-lg overflow-hidden shadow-md group cursor-pointer transition-transform duration-300 hover:shadow-xl"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      {/* Image Section */}
      <div className="relative w-full h-38 bg-gray-200">
        {image ? (
          <Image
            src={image}
            alt={title}
            fill
            className="object-cover"
          />
        ) : null}
      </div>

      {/* Content Section */}
      <CardContent className="px-6 py-3 space-y-3">
        {/* Date */}
        <div className="flex items-center gap-2">
          <Calendar className="w-5 h-5 text-[#F7941D]" />
          <span className="text-gray-600 text-sm font-normal font-['Nunito'] uppercase">
            {date}
          </span>
        </div>

        {/* Title */}
        <h3 className="text-gray-900 text-base font-normal font-['Nunito'] leading-relaxed line-clamp-2">
          {title}
        </h3>

        {/* Link */}
        {link ? (
          <Link
            href={link}
            className="text-[#F7941D] text-base font-normal font-['Nunito'] hover:text-[#e58a1a] transition-colors inline-block"
            onClick={(e) => e.stopPropagation()}
          >
            + detalhes
          </Link>
        ) : null}
      </CardContent>
    </Card>
  )
}
